import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import PolymorphicSchema from "./Polymorphic.js";

var validateSchema = function validateSchema(definition) {
  var isArray = Array.isArray(definition);

  if (isArray && definition.length > 1) {
    throw new Error("Expected schema definition to be a single schema, but found ".concat(definition.length, "."));
  }

  return definition[0];
};

var getValues = function getValues(input) {
  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
    return input[key];
  });
};

var filterEmpty = function filterEmpty(_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      item = _ref2[0],
      deletedItem = _ref2[2];

  return item !== undefined && !deletedItem;
};

export var normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
  schema = validateSchema(schema);
  var values = getValues(input); // Special case: Arrays pass *their* parent on to their children, since there
  // is not any special information that can be gathered from themselves directly

  return values.map(function (value, index) {
    return visit(value, parent, key, schema, addEntity, visitedEntities);
  });
};
export var denormalize = function denormalize(schema, input, unvisit) {
  schema = validateSchema(schema);
  var deleted = false;
  var found = true;

  if (input === undefined && schema) {
    var _unvisit = unvisit(undefined, schema);

    var _unvisit2 = _slicedToArray(_unvisit, 3);

    found = _unvisit2[1];
    deleted = _unvisit2[2];
  }

  return [input && input.map ? input.map(function (entityOrId) {
    return unvisit(entityOrId, schema);
  }).filter(filterEmpty).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        value = _ref4[0];

    return value;
  }) : input, found, deleted];
};

function _infer(schema, args, indexes, recurse) {
  return undefined;
}
/**
 * Represents arrays
 * @see https://resthooks.io/docs/api/Array
 */


export { _infer as infer };

var ArraySchema = /*#__PURE__*/function (_PolymorphicSchema) {
  _inherits(ArraySchema, _PolymorphicSchema);

  var _super = _createSuper(ArraySchema);

  function ArraySchema() {
    _classCallCheck(this, ArraySchema);

    return _super.apply(this, arguments);
  }

  _createClass(ArraySchema, [{
    key: "normalize",
    value: function normalize(input, parent, key, visit, addEntity, visitedEntities) {
      var _this = this;

      var values = getValues(input);
      return values.map(function (value, index) {
        return _this.normalizeValue(value, parent, key, visit, addEntity, visitedEntities);
      }).filter(function (value) {
        return value !== undefined && value !== null;
      });
    }
  }, {
    key: "denormalize",
    value: function denormalize(input, unvisit) {
      var _this2 = this;

      var deleted = false;
      var found = true;

      if (input === undefined && this.schema) {
        var _unvisit3 = unvisit(undefined, this.schema);

        var _unvisit4 = _slicedToArray(_unvisit3, 3);

        found = _unvisit4[1];
        deleted = _unvisit4[2];
      }

      return [input && input.map ? input.map(function (entityOrId) {
        return _this2.denormalizeValue(entityOrId, unvisit);
      }).filter(filterEmpty).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
            value = _ref6[0];

        return value;
      }) : input, found, deleted];
    }
  }, {
    key: "infer",
    value: function infer(args, indexes, recurse) {
      return _infer(this.schema, args, indexes, recurse);
    }
  }]);

  return ArraySchema;
}(PolymorphicSchema);

export { ArraySchema as default };